import Splide from '@splidejs/splide';
import { splideTexts } from './splideTexts';
(function ($) {
    $(function () {
        // new reviews? bail early
        if ($('.jameda-reviews').length === 0) {
            return;
        }
        $('.jameda-reviews').each(function (i, el) {
            var slider = new Splide(el, {
                type: 'loop',
                i18n: splideTexts('Review'),
                arrows: true,
                pagination: false,
                autoplay: true,
                speed: 750,
            });
            // mount slider
            slider.mount();
        });
    });
})(jQuery);
